import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isAfter, parseISO, format } from 'date-fns';

import {
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  FormGroup,
  Label,
  ModalFooter
} from 'reactstrap';
import { DebounceInput } from 'react-debounce-input';
import * as commonActions from '@common/common.action';
import WebapiCommon from '@util/webapi.common';
import { acessoPermitido } from '../../../../acessos.seguranca';
import * as acessos from '../../../../acessos.const.util';
import CommonFunctions from '../../../../app/common/util/functions.common';
import IntlMessage from "../../../../helpers/intlMessage";

function DataPrevisaoEntrega() {
  const dispatch = useDispatch();
  const detalhes = useSelector(state => state.commonReducer.detalhes);
  const usuario = useSelector(state => state.usuario);
  const [modalData, setModalData] = useState(false);
  const [dataEntregaPrevista, setDataEntregaPrevista] = useState();

  useEffect(() => {
    setDataEntregaPrevista(detalhes.dataEntregaPrevista);
  }, [detalhes.dataEntregaPrevista]);

  const toggle = () => setModalData(!modalData);

  const editarDataPrevistaEntregaLaudo = () => {
    if (dataEntregaPrevista) {
      const dataAtual = format(new Date(), 'yyyy-MM-dd');

      if (isAfter(parseISO(dataAtual), parseISO(dataEntregaPrevista))) {
        const message = 'A data não pode ser inferior a data atual';
        dispatch(commonActions.showAlerta('alerta', message, 3000));
        return;
      }

      dispatch(commonActions.showFadeCarregando(true));
      WebapiCommon.editarDataPrevistaEntregaLaudo(
        detalhes.laudo,
        dataEntregaPrevista
      ).then(() => {
        dispatch(
          commonActions.atualizarDetalhes({ ...detalhes, dataEntregaPrevista})
        );

        toggle();
        dispatch(commonActions.showFadeCarregando(false));
        const message = 'Data de entrega atualizada';
        dispatch(commonActions.showAlerta('sucesso', message, 1500));
      });
    } else {
      dispatch(commonActions.showAlerta('alerta', 'Data inválida', 1500));
      toggle();
    }
  };

  return (
    <div className='mv-data-prevista-componente'>
      <div style={{ display: 'flex' }}>
        <strong>Data prevista entrega:</strong>
        <div className='btn-atualizar'>
          {detalhes.dataEntregaPrevista !== ''
            ? ` ${dataEntregaPrevista}`
            : ''}
          {acessoPermitido(usuario, acessos.DataPrevistaEntrega) &&
            detalhes.dtConclusao === '' && (
              <i
                className='mv-basico-atualizar'
                style={{ padding: '0 5px', fontSize: '17px' }}
                onClick={toggle}
                data-toggle='tooltip'
                title='Alterar data prevista de entrega'
              ></i>
            )}
        </div>
      </div>
      {acessoPermitido(usuario, acessos.DataPrevistaEntrega) && (
        <Modal centered size='sm' isOpen={modalData} toggle={toggle} className='mv-modal-data-prevista'>
          <ModalHeader toggle={toggle}></ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>Data prevista para entrega do exame</Label>
              <DebounceInput
                debounceTimeout={900}
                placeholder='DD/MM/AAAA'
                type='date'
                value={detalhes.dataEntregaPrevista}
                onChange={event => setDataEntregaPrevista(CommonFunctions.formatDate(event.target.value))}
                min={new Date().toISOString().slice(0, 10)}
              />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color='secondary' onClick={toggle}>
              <IntlMessage id="dashboards.examDetails.cancel" />
            </Button>
            <Button color='primary' onClick={editarDataPrevistaEntregaLaudo}>
              Confirmar
            </Button>
          </ModalFooter>
        </Modal>
      )}
    </div>
  );
}

export default DataPrevisaoEntrega;



// WEBPACK FOOTER //
// ./src/pages/laudo/detalhesExame/DataPrevisaoEntrega/index.js